const map = {
	"./SchemaWidget/SchemaWidgetClass.ts": 77468,
	"./SchemaWidget/SchemaWidgetComponent.tsx": 43933,
	"./SchemaWidget/SchemaWidgetEditingConfig.ts": 88978,
	"./SchemaWidget/Schemas/bookJsonLd.ts": 5683,
	"./SchemaWidget/Schemas/collegeOrUniversityJsonLd.ts": 712,
	"./SchemaWidget/Schemas/contactPointJsonLd.ts": 77344,
	"./SchemaWidget/Schemas/creativeWorkJsonLd.ts": 43226,
	"./SchemaWidget/Schemas/educationalOccupationalProgramJsonLd.ts": 8309,
	"./SchemaWidget/Schemas/educationalOrganizationJsonLd.ts": 42196,
	"./SchemaWidget/Schemas/eventJsonLd.ts": 46820,
	"./SchemaWidget/Schemas/index.ts": 45770,
	"./SchemaWidget/Schemas/jobPostingJsonLd.ts": 39053,
	"./SchemaWidget/Schemas/personJsonLd.ts": 65211,
	"./SchemaWidget/Schemas/postalAddressJsonLd.ts": 5333,
	"./SchemaWidget/Schemas/productJsonLd.ts": 88551,
	"./SchemaWidget/Schemas/reviewJsonLd.ts": 21286
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46285;